import { createAsyncThunk } from '@reduxjs/toolkit';

import { USER_ROLES } from 'constants/common';

import * as api from 'api/methods';

import * as types from './types';

export const getLessonReports = createAsyncThunk<any, any>(
  types.GET_LESSON_REPORTS,
  async (params: Record<string, any>, { getState }: { getState: any }) => {
    const state = getState() as any;

    const user = state.auth.user;

    const isRootAdmin = user.role === USER_ROLES.ROOT_ADMIN;

    const reports = isRootAdmin
      ? await api.getLessonsReports(params)
      : await api.getSchoolLessonReports({ schoolId: user.schoolId, params });

    return reports;
  },
);

export const getLessonReportsByStudentId = createAsyncThunk<any, any>(
  types.GET_LESSON_REPORTS_BY_STUDENT_ID,
  async ({
    studentId,
    ...params
  }: {
    studentId: string;
    params: Record<string, any>;
  }) => {
    const reports = await api.getLessonsReportsByStudentId({
      studentId,
      params,
    });

    return reports;
  },
);
